import React from 'react'

const ArrowIcon = (props) =>(
	<svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12"><path d="M1.768 0l-1.768 1.7 4.464 4.3-4.464 4.3 1.768 1.7 6.232-6z" fill={props.fill}/></svg>
)

export default ArrowIcon